<template>
  <v-container grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 md10 offset-md1>
        <v-card>
          <v-card-text>
            <p class="subheading"><strong>The institute shall provide academic excellence in the field of Information and Communication Technology, with emphasis on the following goals:</strong></p>
            <p class="subheading">&#9679; Produce quality, excellent and environmentally pro-active graduates imbued with gender responsiveness. </p>
            <p class="subheading">&#9679; Achieve highest level of accreditation and center of excellence imbued with outcomes-based education. </p>
            <p class="subheading">&#9679; Partner with national and international industries as an outlet for research development and extension. </p>
            <p class="subheading">&#9679; Support faculty members through faculty development programs to be competitive with the highest global standards. </p>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  
}
</script>



// WEBPACK FOOTER //
// src/components/HomePage/About/Goals.vue